import React from 'react';
import ReactDOM from 'react-dom/client';
import FreelancerRoster from './FreelancerRoster';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <FreelancerRoster />
  </React.StrictMode>
);
